import { render, staticRenderFns } from "./Hobby.vue?vue&type=template&id=28cf338d&scoped=true&lang=html"
import script from "./Hobby.vue?vue&type=script&lang=js"
export * from "./Hobby.vue?vue&type=script&lang=js"
import style0 from "./Hobby.vue?vue&type=style&index=0&id=28cf338d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf338d",
  null
  
)

export default component.exports